export const getFirstLetterUpperCased = (str: string) => {
  return str[0].toUpperCase() + str.slice(1);
};

const DATE_LOCALES: { [key: string]: string } = {
  kz: "kk-KK",
  ru: "ru-RU",
};

export function formatNewsDate(dateString: string, lang: string) {
  return new Date(dateString).toLocaleDateString(DATE_LOCALES[lang], {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
}

export function formatArticleDate(dateString: string, lang: string) {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date
    .toLocaleDateString(DATE_LOCALES[lang] || "ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    })
    .replace(" г.", "")
    .replace(" ж.", "");
}

export const getUrlLang = (lang: string) => (lang === "ru" ? "/ru" : "");

export const getBlogAssetUrl = (url?: string | null) => {
  if (!url) {
    return "";
  }

  try {
    const parsedUrl = new URL(url);

    if (
      parsedUrl.origin === "https://apigw.jusaninvest.kz" &&
      parsedUrl.pathname.startsWith("/hades/api/v1/")
    ) {
      return `/api/proxy/hades${parsedUrl.pathname.replace("/hades/api/v1", "")}${parsedUrl.search}`;
    }
  } catch {
    return url;
  }

  return url;
};
